// import './App.css';
import "./assets/css/style.css";
import "./assets/css/service-cards.css";
import "./assets/css/style.min.css";
import "./assets/css/animate.css";
import "./assets/css/sidenav.css";
import "./assets/css/vendor/bootstrap.min.css";
// import "bootstrap/dist/css/bootstrap.css"
// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap/dist/css/bootstrap.css.map"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./screens/landing/index";
import AboutUs from "./screens/aboutus/index";
import Services from "./screens/services/index";



function App() {
  return (
    <Router>
      <Routes>
        <Route path={"/"} element={<LandingPage />} />
        <Route path={"/about-us"} element={<AboutUs />} />
        <Route path={"/services"} element={<Services />} />
      </Routes>
    </Router>
  );
}

export default App;
